// @flow
import React from 'react';
import styled from 'styled-components';
import miniLoader from 'assets/images/mini_loader2.gif';

type Props = {
  show: boolean,
}

const Container = styled.div`
  margin: 15px 0px;
`;

const LoaderImage = styled.img`
`;

export default (props: Props) => {
  const show = { props };
  if (show) {
    return (
      <Container>
        <LoaderImage alt="Spinner" src={miniLoader} />
      </Container>
    );
  }

  return null;
};
